import * as React from 'react';
import { SVGProps } from 'react';

const FileIconXlsSizeM = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 34 40" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M32 0H2a2 2 0 0 0-2 2v36a2 2 0 0 0 2 2h30a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2Z" />
    <path
      opacity={0.6}
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9 19h6v2.5H9V19Zm-1 3.5V18h18v15H8V22.5Zm17-1V19h-4v2.5h4Zm-4 1h4V25h-4v-2.5Zm-1-1V19h-4v2.5h4Zm-4 1h4V25h-4v-2.5Zm-1 0V25H9v-2.5h6Zm5 9.5h-4v-2.5h4V32Zm-5 0v-2.5H9V32h6Zm5-3.5h-4V26h4v2.5Zm-5 0V26H9v2.5h6Zm10 0V26h-4v2.5h4Zm-4 1h4V32h-4v-2.5Z"
      fill="#fff"
    />
    <path
      d="M12 12h-1v-2h1V9h-1V7h1v1.5l1 .5 1-.5V7h1v2h-1v1h1v2h-1v-1.5l-1-.5-1 .5V12ZM17.92 12c-.227 0-.527-.08-.7-.24-.167-.16-.22-.413-.22-.76V6h-1V5h2v5.7c0 .107.027.183.08.23.053.047.143.07.27.07H19v1h-1.08ZM23 10.75c0 .42-.13.733-.39.94-.253.207-.623.31-1.11.31H20v-1h1.45c.18 0 .317-.037.41-.11a.423.423 0 0 0 .14-.34v-.1c0-.3-.143-.45-.43-.45h-.37c-.467 0-.667-.1-.9-.3-.227-.207-.3-.53-.3-.97v-.47c0-.447.087-.767.34-.96.253-.2.667-.3 1.16-.3H23v1h-1.45c-.167 0-.3.04-.4.12-.1.073-.15.183-.15.33v.11c0 .153.043.267.13.34.093.073.21.1.35.1h.15c.447 0 .787.12 1.02.34.233.213.35.533.35.96v.45Z"
      fill="#fff"
    />
  </svg>
);
export default FileIconXlsSizeM;
